module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/BD-2aa46cce27df8dca4f379e53eb74f41f.png";